import { Link, useLocation, useNavigate } from 'react-router-dom';
import classes from './Header.module.css'
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Store/store';

const Header = () => {

    
    const location = useLocation()
    const isAuth = useSelector((state:RootState)=>state.user.isAuth)
    
    return ( 
    <header className={classes.header}>
        <div className={classes.container}>
            <div className={classes.text}>
                #ЗАОДНО <span> ДОБРО </span>
            </div> 
            {
                isAuth?
                location.pathname==="/accaunt" || location.pathname ==="/edit"?
                <Link className={classes.link} to={'/education'}>МОЁ ОБУЧЕНИЕ</Link>
                :
                <Link className={classes.link} to={'/accaunt'}>ЛИЧНЫЙ КАБИНЕТ</Link>
                :
                <></>
                
            } 
        </div>
    </header>
     );
}
 
export default Header;